import script from "./jiatingchengyuan.vue?vue&type=script&setup=true&lang=js"
export * from "./jiatingchengyuan.vue?vue&type=script&setup=true&lang=js"

import "./jiatingchengyuan.vue?vue&type=style&index=0&id=00e2b5e0&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00e2b5e0"]])

export default __exports__